import axios, {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse,
  RawAxiosRequestHeaders,
} from 'axios';

export const defaultHeaders: RawAxiosRequestHeaders = {
  Authorization: 'InformMe-Frontend-sy0JTUPvyjIiBpTe55KaqIriOaG',
  'x-app-id': 'InformMe-Frontend-sy0JTUPvyjIiBpTe55KaqIriOaG',
  'Content-Type': 'application/json',
};

export class AwsAxiosConfig {
  // export default headers
  static defaultHeaders = defaultHeaders;

  /** executes request with default baseUrl, auth headers and timeout for calls to orgolas/bunduril services.
   * doesn't overwrite existing values in the reqConfig */
  public static awsRequest(reqConfig: AxiosRequestConfig): Promise<AxiosResponse<any, any>> {
    reqConfig.headers = { ...defaultHeaders, ...(reqConfig.headers || {}) };
    reqConfig.method = reqConfig.method || 'get';

    // console.log(reqConfig);

    return axios.request(reqConfig);
  }

  /**  returns res.data or undefined if error and handles errors by simply logging them
   * use this if you don't want to handle errors further up and just want to return undefined if there is an error */
  static async safeRequest(reqConfig: AxiosRequestConfig): Promise<any | undefined> {
    const methodDescription = `safeRequest(${reqConfig.method} ${reqConfig.url})`;
    // console.log(`=> ${methodDescription}`);
    const startTime = Date.now();
    try {
      const res: AxiosResponse = await this.awsRequest(reqConfig);
      // console.log(
      //   `<= response: ${JSON.stringify(res.data)} response-time: ${Date.now() - startTime}`,
      // );
      return res.data;
    } catch (err: unknown) {
      if (axios.isAxiosError(err) && err.response) {
        console.log(`<x Axios Error in ${methodDescription}:`, err.response.data);
      } else {
        console.log(
          `<x Axios Error in ${methodDescription}`,
          err instanceof Error ? err.message : String(err),
        );
      }
      console.log(
        `Axios Error in ${methodDescription}: ${err instanceof Error ? err.message : String(err)}`,
      );
    }
  }

  /** use this if error handling is done further up and you need the response and want an error to handle otherwise. */
  static async simpleRequest(reqConfig: AxiosRequestConfig) {
    const res = await AwsAxiosConfig.awsRequest(reqConfig);
    return res.data;
  }

  static getErrorMessageFromAxiosError(error: any, defaultMessage = 'An error occurred'): string {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError;
      const responseData = axiosError.response?.data;

      if (responseData) {
        // Handle validation errors (array of error messages)
        if (
          (responseData as any).validationErrors &&
          Array.isArray((responseData as any).validationErrors)
        ) {
          return `Validation errors: ${(responseData as any).validationErrors.join('; ')}`;
        }

        // Handle errors with a message field
        if ((responseData as any).message) {
          return (responseData as any).message;
        }

        // Handle string responses
        if (typeof responseData === 'string') {
          return responseData;
        }
      }
    }

    // Handle regular Error objects
    if (error instanceof Error && error.message) {
      return error.message;
    }

    // Fallback
    return defaultMessage;
  }
}
